import shopifyGenericDefaults from '../shopify-generic/config.js';

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  defaultView: 'active1',
  infiniteScrollEnabled: false,
  pagination: {
    edgeRange: 0,
    centralRange: 2,
    disableDelimiters: true,
  },
};
